import React, { memo, useEffect, useState } from 'react';
import { Button } from '@mui/material';

import { Editor, CardWrapper, useHookForm } from '@monorepo/common';

import { ArrowRight as ArrowRightIcon } from '../../../../components/Icons/arrow-right';
import { IEventsStepProps } from '../../interfaces';
import { IStep3Form } from './formInterface';
import { schema } from './schema';
import { ShortDescriptionField } from '../../../../components/ShortDescriptionField';
import { replaceLineBreaks } from '../../../../utils/shortDescription';
import JobDescriptionTitle from '../../../../components/JobStepper/components/JobDescriptionTitle';

interface IStep4Props extends IEventsStepProps {
  defaultData: IStep3Form | null,
  setStep3: (value: IStep3Form) => void,
}

const empty:string = '<p><br></p>';
export const Step3 = memo(({ onBack, onNext, setStep3, defaultData, Nav }:IStep4Props) => {
  const [editorValue, setEditorValue] = useState<string>(defaultData?.jobDescription || empty);
  const [changedFields, setChangedFields] = useState< IStep3Form | null>(null);
  const {
    register,
    handleSubmit,
    setValue,
    errors
  } = useHookForm<IStep3Form>({
    schema,
    showChangedFields: (a) => {
      setChangedFields(a);
    }
  });
  const editorChange = (res: string) => {
    setEditorValue(res);
  };

  const submit = (data:IStep3Form) => {
    if (setStep3 && onNext) {
      setStep3(data);
      onNext();
    }
  };

  const goBack = () => {
    if (onBack) {
      if (changedFields && (JSON.stringify(defaultData).toString() !== JSON.stringify(changedFields))) {
        setStep3(changedFields);
      }
      onBack();
    }
  };

  useEffect(() => {
    if (editorValue === '<p><br></p>') {
      setValue('jobDescription', null);
      return;
    }
    setValue('jobDescription', editorValue.trim());
  }, [editorValue]);

  useEffect(() => {
    if (defaultData) {
      setValue('jobDescription', defaultData.jobDescription === '<p><br></p>' ? null : defaultData.jobDescription);
      setValue('shortDescription', defaultData.shortDescription && replaceLineBreaks(defaultData.shortDescription));
    }
  }, []);

  return (
    <CardWrapper>
      <JobDescriptionTitle />
      <form
        data-cy="step4"
        onSubmit={handleSubmit(submit)}
      >
        <Editor
          isRequired
          value={editorValue}
          onChange={editorChange}
          error={errors.jobDescription ? (errors.jobDescription.message as string | null) : null}
          fieldCommentBottom="We recommend including the job description, job requirements, and candidate qualifications as well as some information about the company."
        />

        <ShortDescriptionField
          extraProps={{ ...register('shortDescription') }}
          errors={errors}
        />

        <Nav
          nextDisabled={false}
          onBack={goBack}
          nextButton={(
            <Button
              endIcon={(<ArrowRightIcon fontSize="small" />)}
              variant="contained"
              data-cy="nextStep"
              disabled={false}
              type="submit"
            >
              Next Step
            </Button>
                )}
        />
      </form>
    </CardWrapper>
  );
});
